module.exports = __webpack_public_path__ + "img/Chart-Pie-Color.5da3ed8d.png";